import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import {
  ExportOrganizerApi,
  GetOrganizerReportApi,
} from "../../../api/request/reports/report.js";
import MySegmented from "../../../components/segmented/Segmented.jsx";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reports/organizerReport.js";
import Eye from "../../../assets/Eye.jsx";
import AuditModal from "./components/AuditModal.jsx";
import { Button } from "antd";
import Export from "../../../assets/Export.jsx";
import FileSaver from "file-saver";
import { useNavigate } from "react-router-dom";
import Audit from "../../../assets/Audit.jsx";

const OrganizerReport = () => {
  const navigate = useNavigate();
  const [segmentedValue, setSegmentedValue] = useState("Blank Created");
  const [organizerReportList, setOrganizerReportList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isReportFileLoading, setIsReportFileLoading] = useState(false);
  const [selectedOrganizer, setSelectedOrganizer] = useState(null);
  const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);

  const getFilterStatus = (type) => {
    switch (type) {
      case "Blank Created":
        return 1;
      case "Not Completed":
        return 2;
      case "Submitted":
        return 3;
      case "Finished":
        return 4;
      default:
        return 1;
    }
  };

  const getOrganizerReportList = async () => {
    try {
      setIsLoading(true);
      let params = { type: getFilterStatus(segmentedValue) };
      const { data } = await GetOrganizerReportApi(params);
      if (data?.status) {
        setOrganizerReportList(
          data?.data?.map((item) => {
            return {
              ...item,
              ...item?.user,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer_name_slug}
                </div>
              ),
              submit: item?.is_submit ? "Yes" : "No",
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              status: (
                <p
                  className={`${
                    item?.status == "active" ? "text-green-500" : "text-red-600"
                  } font-bold uppercase`}
                >
                  {item?.status}
                </p>
              ),
              action: (
                <div className="flex items-center gap-4">
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/report/organizer/review/${item?.id}`)
                    }
                  >
                    <Eye />
                  </div>
                  <div
                    title="View Audit"
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedOrganizer(item);
                      setIsAuditModalOpen(true);
                    }}
                  >
                    <Audit />
                  </div>
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setOrganizerReportList([]);
      setIsLoading(false);
    }
  };

  const exportReportFile = async (type) => {
    try {
      setIsReportFileLoading(true);
      const headers = { responseType: "blob" };
      const response = await ExportOrganizerApi({ type: type }, headers);

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName =
        type === "Submitted"
          ? "organizer-submitted-report.xlsx"
          : "organizer-finished-report.xlsx";
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
    } finally {
      setIsReportFileLoading(false);
    }
  };

  useEffect(() => {
    getOrganizerReportList();
  }, [segmentedValue]);

  return (
    <>
      <div>
        <MySegmented
          options={["Blank Created", "Not Completed", "Submitted", "Finished"]}
          value={segmentedValue}
          setValue={setSegmentedValue}
        />

        <div className="border-2 rounded-xl my-5">
          <div className="flex justify-between mx-5 mt-5">
            <p className="font-semibold text-2xl">Organizer Reports</p>
            {["Submitted", "Finished"].includes(segmentedValue) && (
              <Button
                type="primary"
                loading={isLoading || isReportFileLoading}
                className="flex "
                onClick={
                  isLoading || isReportFileLoading
                    ? undefined
                    : () => exportReportFile(segmentedValue)
                }
              >
                {isLoading || isReportFileLoading ? (
                  isLoading ? (
                    "Loading"
                  ) : (
                    "Exporting"
                  )
                ) : (
                  <div className="flex gap-2">
                    <Export />
                    <span className="text-base">Export</span>
                  </div>
                )}
              </Button>
            )}
          </div>
          <div className="my-6">
            <SkeletonTable
              columns={columns}
              searchingFields={["name", "email"]}
              dateFilterFields={["startDate"]}
              data={organizerReportList}
              isLoading={isLoading}
              pagination={true}
            />
          </div>
        </div>
      </div>

      <AuditModal
        organizer={selectedOrganizer}
        isOpen={isAuditModalOpen}
        setIsOpen={setIsAuditModalOpen}
      />
    </>
  );
};

export default OrganizerReport;
